import { Fragment, useContext, useEffect, useState } from 'react'
import Container from '../../../../../constants/Container'
import { Grid, Typography } from '@mui/material'
import { BillingContext } from '../../../../../context/BillinEntryContext';
import SelectInputBox from '../../../../../constants/SelectInputBox';
import useFetchSubData from '../../../../../helpers/useSubFetch';
import AppURL from '../../../../../constants/AppURL';
import { NepaliMonthOptions, SearchMemberListOptions } from '../../../../../constants/Options';
import SecHeading from '../../../../../constants/SecHeading';
import { CiCreditCard1 } from 'react-icons/ci';
import InputTextBox from '../../../../../constants/InputTextBox';
import { TbRosetteNumber6 } from 'react-icons/tb';
import NumberTextBox from '../../../../../constants/NumberTextBox';
import DefaultSelectInputBox from '../../../../../constants/DefaultSelectBox';
import { NowNepaliMonthName, NowNepaliYearName } from '../../../../../constants/DateFormat';
interface TopHeaderFormProps {
    bill_no: number;
}
const TopHeaderFormView: React.FC<TopHeaderFormProps> = ({ bill_no }) => {
    const [onSearchMem, setOnSearchMem] = useState("");
    const deposit_year = NowNepaliYearName();
    const deposit_month = NowNepaliMonthName();
    const handleSelect = (item: string) => {
        setOnSearchMem(item);
    };
    const { data: member_data, loading: member_loading, error: member_error } = useFetchSubData(`${AppURL.ApplicationURL}app/all/member/search/report/list/?search=${onSearchMem}`, onSearchMem);
    const searchMemberListOptions = SearchMemberListOptions(member_data?.results);
    const context = useContext(BillingContext);
    if (!context) {
        return <Typography>Error: Context not available</Typography>;
    }
    const handleSelectBox = (name: string, selectedOption: any) => {
        const value = selectedOption ? selectedOption.value : null;
        setFieldValue(name, value);
    };
    const { values, setFieldValue, handleChange, handleBlur, touched, errors } = context;
                    
    return (
        <Fragment>
            <Container padding={true}>
                <SecHeading type='update' label='Billing Entry' icon={<CiCreditCard1 />} />
                <Grid container spacing={1}>
                    <Grid item lg={3} md={3} xs={12} xl={3} sm={12}>
                        <SelectInputBox
                            label='Member Search'
                            options={searchMemberListOptions}
                            optionSelect={(name, selectedOption) => {
                                setFieldValue('mem_name', selectedOption.mem_name);
                                setFieldValue('deposit_year', deposit_year);
                                setFieldValue('deposit_month', parseInt(deposit_month));
                                setFieldValue('marga_tole_name', selectedOption.tole_name);
                                handleSelectBox(name, selectedOption);
                            }}
                            isLoading={false}
                            value={values.member_sn}
                            required={true}
                            placeholder='Select Member List'
                            name='member_sn'
                            handleBlur={handleBlur}
                            debouncedHandleInputChange={handleSelect}
                            touched={touched.member_sn}
                            errors={errors.member_sn}
                        />
                    </Grid>
                    <Grid item lg={3} md={3} xs={12} xl={3} sm={12}>
                        <InputTextBox
                            type='number'
                            prefix={<TbRosetteNumber6 />}
                            label='Billing No.'
                            disabled
                            name='billing_no'
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={bill_no}
                            placeholder='0.00'
                            error={errors.billing_no}
                            required={true}
                        />
                    </Grid>
                    <Grid item lg={3} md={3} xs={12} xl={3} sm={12}>
                        <NumberTextBox
                            type="number"
                            label="Year"
                            name="deposit_year"
                            handleChange={handleChange}
                            handleBlur={handleBlur}
                            value={values.deposit_year}
                            placeholder="XXXX"
                            error={errors.deposit_year}
                            required={true}
                            onPlusClick={() => {
                                const plusYear = parseInt(values.deposit_year || "0") + 1;
                                setFieldValue("deposit_year", plusYear);
                            }}
                            onMinusClick={() => {
                                const plusYear = parseInt(values.deposit_year || "0") - 1;
                                setFieldValue("deposit_year", plusYear);
                            }}
                        />
                    </Grid>
                    <Grid item lg={3} md={3} xs={12} xl={3} sm={12}>
                        <div className='-mt-1'>
                            <DefaultSelectInputBox
                                label='Month'
                                options={NepaliMonthOptions}
                                optionSelect={(name, selectedOption) => {
                                    handleSelectBox(name, selectedOption);
                                }}
                                value={values.deposit_month}
                                required={true}
                                placeholder='Select deposit month'
                                name='deposit_month'
                                handleBlur={handleBlur}
                                touched={touched.deposit_month}
                                errors={errors.deposit_month}
                            />
                        </div>
                    </Grid>
                </Grid>
            </Container>
        </Fragment>
    )
}

export default TopHeaderFormView